import { type Modification } from '../../types';

/**
 * Returns a map of modification group names to their total count.
 */
export function getActiveModificationsCount(params: Params) {
  const { activeModifications } = params;

  return activeModifications.reduce<Record<string, number>>(
    (allEntries, modification) => {
      const { modificationGroupName, quantity } = modification;

      const currentQuantity = allEntries[modificationGroupName] ?? 0; // prettier-ignore
      const updatedQuantity = currentQuantity + quantity;

      return { ...allEntries, [modificationGroupName]: updatedQuantity };
    },
    {},
  );
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  activeModifications: Modification[];
};
